/**
 * Created by: cparaschiv
 * Date: 04.04.2013, 17:50
 */

TS.ns('TS.cultures');

(function(window, undefined) {
    TS.cultures['en-GB'] = {
        name: 'en-GB',
        language: "en-GB",
        decimalseparator: ',',
        thousandsseparator: ' ',
        numberFormat: {
            ',': " ",
            '.': ",",
            percent: {
                ',': " ",
                '.': ","
            },
            currency: {
                pattern: ["-n $", "n $"],
                ',': " ",
                '.': ",",
                symbol: "€"
            }
        },
        common: {
            Add: 'Add',
            Edit: 'Edit',
            Delete: 'Delete',
            Save: 'Save',
            Close: 'Close',
            Cancel: 'Cancel',
            Confirm: 'Confirm',
            Yes: 'Yes',
            No: 'No',
            EmptySelection: '<unspecified>'
        },

        sessionExpired: {
            Title: 'Session has expired',
            Message: 'Redirecting to start page.'
        },

        error: {
            LoadError: 'Error loading data'
        },

        edit: {
            InvalidDocument: 'This document is not valid. Fix validation errrors and try again.'
        },

        list: {
            NoRecordSelected: 'Select at least one record',
            DeleteSelectedRecords: 'Are you sure you want to delete selected records?'
        },

        gridLocalization: {
            // separator of parts of a date (e.g. '/' in 11/05/1955)
            '/': ".",
            // separator of parts of a time (e.g. ':' in 05:44 PM)
            ':': ":",
            // the first day of the week (0 = Sunday, 1 = Monday, etc)
            firstDay: 1,
            days: {
                names: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
                namesAbbr: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
            },
            months: {
                names: ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "novembere", "december", ""],
                namesAbbr: ["jan.", "feb.", "mar.", "apr.", "may.", "jun.", "jul.", "aug.", "sep.", "oct.", "nov.", "dec.", ""]
            },
            // AM and PM designators in one of these forms:
            // The usual view, and the upper and lower case versions
            //      [standard,lowercase,uppercase]
            // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
            //      null
            AM: ["AM", "am", "AM"],
            PM: ["PM", "pm", "PM"],
            eras: [
                // eras in reverse chronological order.
                // name: the name of the era in this culture (e.g. A.D., C.E.)
                // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                // offset: offset in years from gregorian calendar
                { "name": "A.D.", "start": null, "offset": 0 }
            ],
            twoDigitYearMax: 2029,
            patterns: {
                // short date pattern
                d: "dd.MM.yyyy",
                // long date pattern
                D: "dddd, dd MMMM, yyyy",
                // short time pattern
                t: "h:mm tt",
                // long time pattern
                T: "h:mm:ss tt",
                // long date, short time pattern
                f: "dddd, dd MMMM, yyyy h:mm tt",
                // long date, long time pattern
                F: "dddd, dd MMMM, yyyy h:mm:ss tt",
                // month/day pattern
                M: "dd MMMM",
                // month/year pattern
                Y: "MMMM yyyy",
                // S is a sortable format that does not vary by culture
                S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                // formatting of dates in MySQL DataBases
                ISO: "yyyy-MM-dd hh:mm:ss",
                ISO2: "yyyy-MM-dd HH:mm:ss",
                d1: "dd.MM.yyyy",
                d2: "dd-MM-yyyy",
                d3: "dd-MMMM-yyyy",
                d4: "dd-MM-yy",
                d5: "H:mm",
                d6: "HH:mm",
                d7: "HH:mm tt",
                d8: "dd/MMMM/yyyy",
                d9: "MMMM-dd",
                d10: "dd-MM",
                d11: "dd-MM-yyyy"
            },
            percentsymbol: "%",
            currencysymbol: "RON",
            currencysymbolposition: "forward",
            decimalseparator: ',',
            thousandsseparator: ' ',
            pagergotopagestring: "Go to page:",
            pagershowrowsstring: "Rows no.:",
            pagerrangestring: " of ",
            pagerpreviousbuttonstring: "Previous page",
            pagernextbuttonstring: "Next page",
            groupsheaderstring: "Drag a column and drop it here to group",
            sortascendingstring: "Sort ascending",
            sortdescendingstring: "Sort descending",
            sortremovestring: "Remove ordering",
            groupbystring: "Group by this column",
            groupremovestring: "Remove from groups",
            filterclearstring: "Clear",
            filterstring: "Filter",
            filtershowrowstring: "Show rows:",
            filterorconditionstring: "Or",
            filterandconditionstring: "And",
            filterselectallstring: "(Select all)",
            filterchoosestring: "Choose:",
            filterstringcomparisonoperators: ['unspecified', 'specified', 'contain', 'contain(match letters)',
                'does not contain', 'does not contain(match letters)', 'starts with', 'starts with(match letters)',
                'ends with', 'ends with(match letters)', 'equal', 'equal(match letters)', 'null', 'not null'],
            filternumericcomparisonoperators: ['equal', 'unequal', 'less than', 'less than or equal to', 'greater then', 'greater or equal to', 'null', 'not null'],
            filterdatecomparisonoperators: ['equal', 'unequal', 'less than', 'less than or equal to', 'greater then', 'greater or equal to', 'null', 'not null'],
            filterbooleancomparisonoperators: ['equal', 'unequal'],
            validationstring: "The value entered is not valid",
            emptydatastring: "No data",
            filterselectstring: "Select filter",
            loadtext: "Loading...",
            clearstring: "Delete",
            todaystring: "Today",
            emptyContent: 'No data'
        },

        treeLocalization: {
            AddRoot: 'Add root',
            ExpandAll: 'Expand all',
            CollapseAll: 'Collapse all'
        },

        pagerMessages: {
            display: "Record {0} - {1} of {2}",
            empty: "No data",
            page: "Page",
            of: "of {0}",
            itemsPerPage: "records per page",
            first: "First page",
            previous: "Previous page",
            next: "Next page",
            last: "Last page",
            refresh: "Refresh",
            morePages: "More pages"
        },

        validation: {
            RequiredValue: 'Enter the value',
            InvalidValue: 'The value entered is not valid'
        },

        messageBox: {
            buttons: {
                OK: 'OK',
                Cancel: 'Cancel',
                Abort: 'Abort',
                Retry: 'Retry',
                Ignore: 'Ignore',
                Yes: 'Yes',
                No: 'No'
            }
        },

        fileUploadMessages : {
            Loading: 'Loading...',
            Error: 'Error',
            SelectFile: 'Load',
            InitialDescription: 'Press "Load" button',
            DragOverHint: 'Release the file to start loading.',
            UploadCancelled: 'Loading stopped'
        }
    };

    TS.cultures['en-US'] = {
        name: 'en-US',
        language: "en-US",
        decimalseparator: ',',
        thousandsseparator: ' ',
        numberFormat: {
            ',': " ",
            '.': ",",
            percent: {
                ',': " ",
                '.': ","
            },
            currency: {
                pattern: ["-n $", "n $"],
                ',': " ",
                '.': ",",
                symbol: "€"
            }
        },
        common: {
            Add: 'Add',
            Edit: 'Edit',
            Delete: 'Delete',
            Save: 'Save',
            Close: 'Close',
            Cancel: 'Cancel',
            Confirm: 'Confirm',
            Yes: 'Yes',
            No: 'No',
            EmptySelection: '<unspecified>'
        },

        sessionExpired: {
            Title: 'Session has expired',
            Message: 'Redirecting to start page.'
        },

        error: {
            LoadError: 'Error loading data'
        },

        edit: {
            InvalidDocument: 'This document is not valid. Fix validation errrors and try again.'
        },

        list: {
            NoRecordSelected: 'Select at least one record',
            DeleteSelectedRecords: 'Are you sure you want to delete selected records?'
        },

        gridLocalization: {
            // separator of parts of a date (e.g. '/' in 11/05/1955)
            '/': ".",
            // separator of parts of a time (e.g. ':' in 05:44 PM)
            ':': ":",
            // the first day of the week (0 = Sunday, 1 = Monday, etc)
            firstDay: 1,
            days: {
                names: ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
                namesAbbr: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
                namesShort: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
            },
            months: {
                names: ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "novembere", "december", ""],
                namesAbbr: ["jan.", "feb.", "mar.", "apr.", "may.", "jun.", "jul.", "aug.", "sep.", "oct.", "nov.", "dec.", ""]
            },
            // AM and PM designators in one of these forms:
            // The usual view, and the upper and lower case versions
            //      [standard,lowercase,uppercase]
            // The culture does not use AM or PM (likely all standard date formats use 24 hour time)
            //      null
            AM: ["AM", "am", "AM"],
            PM: ["PM", "pm", "PM"],
            eras: [
                // eras in reverse chronological order.
                // name: the name of the era in this culture (e.g. A.D., C.E.)
                // start: when the era starts in ticks (gregorian, gmt), null if it is the earliest supported era.
                // offset: offset in years from gregorian calendar
                { "name": "A.D.", "start": null, "offset": 0 }
            ],
            twoDigitYearMax: 2029,
            patterns: {
                // short date pattern
                d: "dd.MM.yyyy",
                // long date pattern
                D: "dddd, dd MMMM, yyyy",
                // short time pattern
                t: "h:mm tt",
                // long time pattern
                T: "h:mm:ss tt",
                // long date, short time pattern
                f: "dddd, dd MMMM, yyyy h:mm tt",
                // long date, long time pattern
                F: "dddd, dd MMMM, yyyy h:mm:ss tt",
                // month/day pattern
                M: "dd MMMM",
                // month/year pattern
                Y: "MMMM yyyy",
                // S is a sortable format that does not vary by culture
                S: "yyyy\u0027-\u0027MM\u0027-\u0027dd\u0027T\u0027HH\u0027:\u0027mm\u0027:\u0027ss",
                // formatting of dates in MySQL DataBases
                ISO: "yyyy-MM-dd hh:mm:ss",
                ISO2: "yyyy-MM-dd HH:mm:ss",
                d1: "dd.MM.yyyy",
                d2: "dd-MM-yyyy",
                d3: "dd-MMMM-yyyy",
                d4: "dd-MM-yy",
                d5: "H:mm",
                d6: "HH:mm",
                d7: "HH:mm tt",
                d8: "dd/MMMM/yyyy",
                d9: "MMMM-dd",
                d10: "dd-MM",
                d11: "dd-MM-yyyy"
            },
            percentsymbol: "%",
            currencysymbol: "RON",
            currencysymbolposition: "forward",
            decimalseparator: ',',
            thousandsseparator: ' ',
            pagergotopagestring: "Go to page:",
            pagershowrowsstring: "Rows no.:",
            pagerrangestring: " of ",
            pagerpreviousbuttonstring: "Previous page",
            pagernextbuttonstring: "Next page",
            groupsheaderstring: "Drag a column and drop it here to group",
            sortascendingstring: "Sort ascending",
            sortdescendingstring: "Sort descending",
            sortremovestring: "Remove ordering",
            groupbystring: "Group by this column",
            groupremovestring: "Remove from groups",
            filterclearstring: "Clear",
            filterstring: "Filter",
            filtershowrowstring: "Show rows:",
            filterorconditionstring: "Or",
            filterandconditionstring: "And",
            filterselectallstring: "(Select all)",
            filterchoosestring: "Choose:",
            filterstringcomparisonoperators: ['unspecified', 'specified', 'contain', 'contain(match letters)',
                'does not contain', 'does not contain(match letters)', 'starts with', 'starts with(match letters)',
                'ends with', 'ends with(match letters)', 'equal', 'equal(match letters)', 'null', 'not null'],
            filternumericcomparisonoperators: ['equal', 'unequal', 'less than', 'less than or equal to', 'greater then', 'greater or equal to', 'null', 'not null'],
            filterdatecomparisonoperators: ['equal', 'unequal', 'less than', 'less than or equal to', 'greater then', 'greater or equal to', 'null', 'not null'],
            filterbooleancomparisonoperators: ['equal', 'unequal'],
            validationstring: "The value entered is not valid",
            emptydatastring: "No data",
            filterselectstring: "Select filter",
            loadtext: "Loading...",
            clearstring: "Delete",
            todaystring: "Today",
            emptyContent: 'No data'
        },

        treeLocalization: {
            AddRoot: 'Add root',
            ExpandAll: 'Expand all',
            CollapseAll: 'Collapse all'
        },

        pagerMessages: {
            display: "Record {0} - {1} of {2}",
            empty: "No data",
            page: "Page",
            of: "of {0}",
            itemsPerPage: "records per page",
            first: "First page",
            previous: "Previous page",
            next: "Next page",
            last: "Last page",
            refresh: "Refresh",
            morePages: "More pages"
        },

        validation: {
            RequiredValue: 'Enter the value',
            InvalidValue: 'The value entered is not valid'
        },

        messageBox: {
            buttons: {
                OK: 'OK',
                Cancel: 'Cancel',
                Abort: 'Abort',
                Retry: 'Retry',
                Ignore: 'Ignore',
                Yes: 'Yes',
                No: 'No'
            }
        },

        fileUploadMessages: {
            Loading: 'Loading...',
            Error: 'Error',
            SelectFile: 'Load',
            InitialDescription: 'Press "Load" button',
            DragOverHint: 'Release the file to start loading.',
            UploadCancelled: 'Loading stopped'
        }
    };
})(this);
